import { useMutation } from '@tanstack/react-query';
import UsersService from '../../services/UsersService';

/**
 * Mutation para registrar novo usuário (client ou model)
 */
export function useRegisterUser() {
  return useMutation({
    mutationFn: (data) => UsersService.register(data),
    onError: (error) => {
      console.error('Erro ao registrar usuário:', error);
    },
  });
}

/**
 * Mutation para fazer login (client ou model)
 */
export function useLoginUser() {
  return useMutation({
    mutationFn: (data) => UsersService.login(data),
    onError: (error) => {
      console.error('Erro ao fazer login:', error);
    },
  });
}

/**
 * Mutation para verificar se email já existe
 * Usado pelo fluxo de registro de models
 */
export function useCheckEmailExists() {
  return useMutation({
    mutationFn: (email) => UsersService.findByEmail(email),
    onError: (error) => {
      console.error('Erro ao verificar email:', error);
    },
  });
}

/**
 * Mutation para solicitar redefinição de senha
 */
export function useForgotPassword() {
  return useMutation({
    mutationFn: (email) => UsersService.forgotPassword(email),
  });
}

/**
 * Mutation para redefinir senha com token
 */
export function useResetPassword() {
  return useMutation({
    mutationFn: ({ token, password }) => UsersService.resetPassword(token, password),
  });
}
